import type { ExternalExtensionMessage } from "@punto/frontend-shared/extension";

import { getChromeRuntime } from "./chrome-runtime";
import { EXTENSION_ID } from "./extension-constants";

/**
 * Send a message to the Chrome extension via externally_connectable, not
 * webext-bridge: OPEN_SIDEBAR needs the click's user gesture, and
 * APPLY_UPDATE must reach an extension that reloaded since this tab loaded
 * its content script. Returns false if the Chrome messaging API is unavailable.
 */
export function sendExtensionMessage(
  message: ExternalExtensionMessage,
  callback?: (response: unknown) => void,
): boolean {
  const runtime = getChromeRuntime();
  if (!runtime?.sendMessage) return false;

  runtime.sendMessage(EXTENSION_ID, message, (response: unknown) => {
    if (runtime.lastError) {
      console.error(
        "[Extension] sendMessage failed:",
        runtime.lastError.message,
      );
    }
    callback?.(response);
  });
  return true;
}
